import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./TopBar.css";

function TopBarChinese() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1200);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    let scrollTimeout;
    
    const handleScroll = () => {
      // Hide the navbar while scrolling
      setVisible(false);
      
      // Clear the previous timeout
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      
      // Set a new timeout to show the navbar after scrolling stops
      scrollTimeout = setTimeout(() => {
        setVisible(true);
      }, 200); // Adjust this value to control how long to wait after scrolling stops
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setMenuOpen(false);
    }
  }, [isMobile]);

  return (
    <div className={`top-bar ${visible ? 'visible' : 'hidden'}`}>
      {/* Left section: Logo and Title */}
      <div className="top-bar-left">
        <img 
          src="horizontal_logo.png" 
          alt="Connection Health Care Logo"
          className="top-bar-logo"
        />
        {/* <span style={{ fontWeight: 700, fontSize: '1.5rem', color: '#004080' }}>Connection Health Care</span> */}
        <Link
          to="/"
          className="language-button"
          onClick={() => window.scrollTo(0, 0)}
        >
          English
        </Link>
      </div>

      {/* Desktop navigation tabs (hidden on mobile) */}
      {!isMobile && (
        <div className="top-bar-tabs">
          <Link to="/zh" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>首頁</Link>
          <Link to="/zhservices" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>服務</Link>
          <Link to="/zhbookingform" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>立即預約</Link>
          <Link to="/zhaboutus" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>關於我們</Link>
          <Link to="/zhourteam" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>我們的團隊</Link>
          <Link to="/zhcareer" className="top-bar-tab" onClick={() => window.scrollTo(0, 0)}>職業機會</Link>
          <a href="#contact-form" className="top-bar-tab" onClick={(e) => {
            e.preventDefault();
            const element = document.getElementById('contact-form');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}>聯繫我們</a>
        </div>
      )}

      {/* Mobile menu button */}
      {isMobile && (
        <button
          className="top-bar-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Open menu"
        >
          ☰
        </button>
      )}

      {/* Dropdown menu on mobile when open */}
      {isMobile && menuOpen && (
        <div className="top-bar-dropdown">
          <Link to="/zh" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>首頁</Link>
          <Link to="/zhservices" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>服務</Link>
          <Link to="/zhbookingform" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>立即預約</Link>
          <Link to="/zhaboutus" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>關於我們</Link>
          <Link to="/zhourteam" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>我們的團隊</Link>
          <Link to="/zhcareer" className="top-bar-tab" onClick={() => { window.scrollTo(0, 0); setMenuOpen(false); }}>職業機會</Link>
          <a href="#contact-form" className="top-bar-tab" onClick={(e) => {
            e.preventDefault();
            setMenuOpen(false);
            const element = document.getElementById('contact-form');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}>聯繫我們</a>
        </div>
      )}
    </div>
  );
}

export default TopBarChinese;